export const blockIconsTravelBakeryDiningNew = (
	<span className='material-symbols-outlined'>bakery_dining</span>
);
